/**
 * FormFlu Footer Component
 * 
 * Site footer with links, legal info, and branding.
 */

import './Footer.css';

const footerLinks = {
  product: [
    { label: 'Features', href: '#features' },
    { label: 'Pricing', href: '#pricing' },
    { label: 'Integrations', href: '#integrations' },
    { label: 'Changelog', href: '#changelog' },
  ],
  resources: [
    { label: 'Documentation', href: '#docs' },
    { label: 'API Reference', href: '#api' },
    { label: 'Guides', href: '#guides' },
    { label: 'Support', href: '#support' },
  ],
  company: [
    { label: 'About', href: '#about' },
    { label: 'Blog', href: '#blog' },
    { label: 'Careers', href: '#careers' },
    { label: 'Contact', href: '#contact' },
  ],
  legal: [
    { label: 'Privacy Policy', href: '#privacy' },
    { label: 'Terms of Service', href: '#terms' },
    { label: 'HIPAA Compliance', href: '#hipaa' },
    { label: 'BAA', href: '#baa' },
  ],
};

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        {/* Main Footer Content */}
        <div className="footer-main">
          {/* Brand Column */}
          <div className="footer-brand">
            <img 
              src="/images/finalformflumainlogo.png" 
              alt="FormFlu" 
              className="footer-logo"
            />
            <p className="footer-tagline">
              Turn sick forms into healthy ones. HIPAA-compliant form builder 
              with A/B testing for healthcare organizations.
            </p>
            <div className="footer-badges">
              <span className="footer-badge">
                🔒 HIPAA Compliant
              </span>
              <span className="footer-badge">
                🇺🇸 US Data Centers
              </span>
            </div>
          </div>

          {/* Links Columns */}
          <div className="footer-links">
            <div className="footer-column">
              <h4 className="footer-heading">Product</h4>
              <ul className="footer-list">
                {footerLinks.product.map((link) => (
                  <li key={link.label}>
                    <a href={link.href}>{link.label}</a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-column">
              <h4 className="footer-heading">Resources</h4>
              <ul className="footer-list">
                {footerLinks.resources.map((link) => (
                  <li key={link.label}>
                    <a href={link.href}>{link.label}</a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-column">
              <h4 className="footer-heading">Company</h4>
              <ul className="footer-list">
                {footerLinks.company.map((link) => (
                  <li key={link.label}>
                    <a href={link.href}>{link.label}</a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-column">
              <h4 className="footer-heading">Legal</h4>
              <ul className="footer-list">
                {footerLinks.legal.map((link) => (
                  <li key={link.label}>
                    <a href={link.href}>{link.label}</a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} FormFlu. All rights reserved.
          </p>
          <p className="footer-hipaa-note">
            <strong>HIPAA Compliance:</strong> PHI is encrypted at rest and in transit. 
            We sign BAAs with all customers. No PHI in logs or analytics.
          </p>
        </div>
      </div>
    </footer>
  );
}
